// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["webpack_sharing_provide_default_classnames-webpack_sharing_provide_default_dayjs-webpack_shar-6033e9"], function() { return __webpack_require__("./src/index.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
